import React from "react";
import StyledSwitch from "src/components/StyledSwitch";

export const ToggleSwitch = (props) => (
    <StyledSwitch
        switchWidth={45}
        switchHeight={27}
        switchMarginTop="auto"
        switchMarginBottom="auto"
        checkedTranslateX={18}
        checkedThumbColor="#E8F5E9"
        checkedTrackColor="#4CAF50"
        checkedBorderColor="none"
        focusColor="#4CAF50"
        thumbSize={25}
        trackRadius={29 / 2}
        trackBackgroundColor="#C4C4C4"
        trackBorderColor="none"
        {...props}
    />
);
